<script>
const { VUE_APP_API_HOST } = process.env

export default {
  methods: {
    readAccount(id) {
      return this.$http
        .get(`${VUE_APP_API_HOST}/accounts/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('user-token')}`
          }
        })
        .then(res => res, err => err)
    },

    updateAccount(body) {
      const { id } = body
      delete body.id

      return this.$http
        .put(`${VUE_APP_API_HOST}/accounts/${id}`, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('user-token')}`
          }
        })
        .then(res => res, err => err)
    }
  }
}
</script>